.header {
  position: sticky;
  top: 0;
  z-index: var(--z-index-low);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  height: 64px;
  padding-inline: 20px;
  background-color: var(--color-white);
}

.pageTitle {
  font-size: 15px;
  font-weight: 600;
  line-height: normal;
  color: rgb(0 0 0 / 60%);
}

.left {
  display: flex;
  gap: 23px;
  align-items: center;
}

.middle {
  display: flex;
  justify-content: center;

  /* 左端のボタンは左側のみ角丸 */
  button:first-of-type {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  /* 右端のボタンは右側のみ角丸 */
  button:last-of-type {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  /* 2つ目以降のボタンは左 border を非表示 */
  button:not(:first-of-type) {
    border-left: none;
  }
}

.right {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: end;
}

.button {
  padding: 7.5px 20px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.8;
  letter-spacing: -0.52px;
  border-radius: 8px;

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px white,
      0 0 0 4px rgb(0 0 0 / 50%);
  }
}

.buttonFlat {
  color: var(--color-white);
  background-color: #000;

  &:hover {
    background-color: rgb(77 77 77);
  }
}
